export const SERVICES_RESP = {
  STATUS_OK: 'ST200',
  SUCCESS_CODE: 'OLS0000',
  SUCCESS_TEXT: 'success',
  SESSION_FAILURE: ['0114', 'AUTH0008'],
  SESSION_TIMEOUT: ['0114', 'AUTH0008','AUTH0002','another.place.login'],
  QTY_ERROR_CODE: 'HKSFOE00021',
  SESSION_NOT_FOUND: 'AUTH0002',
  DEVICE_NOT_REGISTERED:'HKSEF0148',
  CHANGE_PASSWORD_FAIL: 'HKSEF0033',
  CHANGE_PASSWORD_FAILS: 'HKSEF0034',
  ANOTHER_PLACE_LOGIN: 'another.place.login',
  SEARCH_ERROR_CODE:'30001',
  SYSTEM_NOT_AVAILABLE: 'OLS000V'
}
